import React from 'react'
import ReactDOM from 'react-dom'
import SEO from '../../../components/SEO'
import SearchForm from '../SearchForm'
import Menu from './Menu'

import('../style.css')

const App = ({ data }) => {
    return (
        <div className="search-page-header-wrapper">
            <SearchForm request={data.request} options={data.options} />
            <Menu links={data.links} user_data={data.user_data} />
        </div>        
    );
}

document.addEventListener('DOMContentLoaded', () => {
    const node = document.getElementById('search_header_data');
    const data = JSON.parse(node.getAttribute('data'));

    ReactDOM.render(
        <App data={data} />,
        document.getElementById('search-header-component-container'),
    );
});